import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Card = styled(Link)`
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  transition: transform 0.3s ease;
  aspect-ratio: 2/3;

  &:hover {
    transform: scale(1.05);
  }
`;

const Poster = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;

  ${Card}:hover & {
    opacity: 1;
  }
`;

const Title = styled.h3`
  font-size: 1rem;
  margin: 0;
  color: white;
`;

const ContentCard = ({ id, title, poster, type }) => {
  // Map the type to the correct route
  const route = type === 'tv' ? 'series' : type;
  
  return (
    <Card to={`/${route}/${id}`}>
      <Poster src={poster} alt={title} />
      <Overlay>
        <Title>{title}</Title>
      </Overlay>
    </Card>
  );
};

export default ContentCard; 